export enum BannerMessageActionTypes {
  SET_BANNER_MESSAGES_SEEN = "SET_BANNER_MESSAGES_SEEN"
}